import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template167: Consejos útiles para París. Todo desde backend.
// page.texts[0]=header, [1]=intro | page.sections[0..n] (icono, texto) | page.images (consejos, enchufe)
const Template167 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const section0 = sections[0];
	const section1 = sections[1];
	const section2 = sections[2];
	const section3 = sections[3];
	const section4 = sections[4];
	const section5 = sections[5];
	const section6 = sections[6];
	const section7 = sections[7];
	const section8 = sections[8];

	const tipsStickerImage = getImageSrc("consejos");
	const tipsSticker2Image = getImageSrc("enchufe");

	const actualHeaderColor = headerBackgroundColor || "#2C3E50";
	const ff = fontFamily || "'Poppins', sans-serif";

	const pStyle = {
		fontFamily: `${ff} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	const tipBox = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "center",
		gap: "10px",
		border: "2px solid #E8F4F8",
	};

	const renderTip = (section) => {
		if (!section?.texto) return null;
		return (
			<Box key={section.texto} sx={tipBox}>
				{section.icono && <Box sx={{ fontSize: 18 }}>{section.icono}</Box>}
				<Box sx={{ fontSize: 13, color: contentColor }}>{section.texto}</Box>
			</Box>
		);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100vh",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${ff} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${ff} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${ff} !important`,
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={pStyle}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "6px",
					position: "relative",
					marginTop: introText ? "0px" : "16px",
				}}
			>
				{renderTip(section0)}
				{renderTip(section1)}
				{renderTip(section2)}
				{renderTip(section3)}
				{renderTip(section4)}
				{renderTip(section5)}
				{renderTip(section6)}
				{renderTip(section7)}
				{renderTip(section8)}

				{tipsStickerImage && (
					<img
						src={tipsStickerImage}
						alt=""
						style={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -60 : 0,
							right: 0,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template167.thumbnail = "/images/template-1.png";

export default Template167;
